import { Observable } from 'rxjs';
import { GeographicAddress, GeographicAddressInput, Locale } from '@iss/libs/graphql';
import { FormControl, Validators } from '@angular/forms';
import { DestroyRef } from '@angular/core';

import { DeepPartial } from '@iss/wo-common/types';
import { ControlsOf, ReactiveFormGroup } from '@iss/core/forms';

export type AddressControls = ControlsOf<GeographicAddressInput>;

const fourDigitsValidator = Validators.pattern(/^\d{4}$/);

export class AddressFormGroup extends ReactiveFormGroup<AddressControls> {

  public static create(
    destroyRef: DestroyRef,
    value?: DeepPartial<GeographicAddress>,
    required = true,
  ): AddressFormGroup {
    const commonValidators = [];
    if (required) {
      commonValidators.push(Validators.required);
    }

    return new this({
      addressLine: new FormControl(value?.addressLine || '', {
        nonNullable: true,
        validators: commonValidators.concat([ Validators.maxLength(255) ]),
      }),
      city: new FormControl(value?.city || '', {
        nonNullable: true,
        validators: commonValidators.concat([ Validators.maxLength(255) ]),
      }),
      // @ts-ignore
      locale: new FormControl(value?.locale, {
        nonNullable: true,
        validators: commonValidators,
      }),
      zipOrPostCode: new FormControl(value?.zipOrPostCode || '', {
        nonNullable: true,
        validators: commonValidators.concat([ Validators.maxLength(255) ]),
      }),
    }, { destroyRef });
  }

  protected woMonitor(): Observable<unknown> {
    return this.controls.locale.valueChanges;
  }

  protected woDoCheck(): void {
    const locale = this.controls.locale.value;
    this.woEnableValidators(this.controls.zipOrPostCode, fourDigitsValidator, [ Locale.Dk ].includes(locale));
  }
}
